<template>
  <div class="w-100">
    <template v-if="$mq==='sm'">
      <div class="d-flex align-items-start justify-content-between mb-3">
        <proa-heading>{{ $t('pages.chat.heading') }}</proa-heading>
        <proa-button v-if="signedInUser.creatable" @click.native="$router.push({ name: 'newChat' })">
          {{ $t('common.createGroupChat') }}
        </proa-button>
      </div>
      <div class="d-flex align-items-end justify-content-between mb-2">
        <proa-heading sub>
          {{ $t('pages.chat.rooms') }}
          <span v-if="groupChats.length">（{{ groupChats.length }}）</span>
        </proa-heading>
      </div>
    </template>
    <template v-else>
      <proa-heading>{{ $t('pages.chat.heading') }}</proa-heading>
      <div class="d-flex align-items-end justify-content-between mt-3 pt-3 mb-3 pb-1">
        <proa-heading sub>
          {{ $t('pages.chat.rooms') }}
          <span v-if="groupChats.length">（{{ groupChats.length }}）</span>
        </proa-heading>
        <proa-button v-if="signedInUser.creatable" @click.native="$router.push({ name: 'newChat' })">
          {{ $t('common.createGroupChat') }}
        </proa-button>
      </div>
    </template>
    <group-chats-card
      :groupChats="groupChats"
      @onClickGroupChat="onClickGroupChat"
      @onClickGroupChatInformation="onClickGroupChatInformation"
      @onClickGroupChatUsers="onClickGroupChatUsers"
    />
    <proa-modal
      :modal="groupChatInformationModal"
      :title="$t('common.detail')"
      @close="groupChatInformationModal = false"
      v-if="focusedGroupChat"
    >
      <proa-heading sub>{{ focusedGroupChat.groupChatName }}</proa-heading>
      <div
        v-if="focusedGroupChat.groupChatDescription"
        v-html="$options.filters.autoLink(focusedGroupChat.groupChatDescription)"
        style="margin-top: 20px; white-space: pre-wrap;"
      />
    </proa-modal>
    <proa-modal
      v-if="focusedGroupChat"
      :modal="groupChatUsersModal"
      :title="`${$t('common.menus.member')}（${focusedGroupChat.isPublic() ? allUsers.length : focusedGroupChat.users.length}${$t('common.person')}）`"
      @close="groupChatUsersModal = false"
    >
      <div v-for="user in focusedGroupChat.isPublic() ? allUsers : focusedGroupChat.users" :key="user.id" style="margin-bottom: 10px;">
        <proa-avatar
          size="sm"
          :src="user.meta.avatar || require('@/assets/images/avatar_default.png')"
        />
        <span class="displayName">
          <span>{{ user.meta.displayName }}</span>
          <span v-if="focusedGroupChat.groupChatOwnerId == user.id" class="owner">オーナー</span>
        </span>
      </div>
    </proa-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import User from '@/store/models/User'
import GroupChat from '@/store/models/GroupChat'
import GroupChatsCard from '@/components/molecules/GroupChatsCard'

export default {
  name: 'IndexChat',
  components: {
    GroupChatsCard
  },
  computed: {
    groupChats: function() {
      return GroupChat.listables()
    },
    allUsers: function() {
      return User.all()
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  data() {
    return {
      groupChatInformationModal: false,
      groupChatUsersModal: false,
      focusedGroupChat: null
    }
  },
  methods: {
    onClickGroupChat:function(id) {
      this.$router.push({ name: 'showChat', params: { id: id } })
    },
    onClickGroupChatInformation: function(id) {
      this.focusedGroupChat = GroupChat.find(id)
      this.groupChatInformationModal = true
    },
    onClickGroupChatUsers: function(id) {
      this.focusedGroupChat = GroupChat.find(id)
      this.groupChatUsersModal = true
    },
    ...mapActions({
      apiGetGroupChats: 'entities/groupChats/index'
    })
  },
  async created() {
    await this.apiGetGroupChats()
  }
}
</script>

<style  lang="scss">
@import "@/styles/variables";

.displayName {
  display: inline-flex;
  margin-left: 10px;

  .owner {
    margin-left: 10px;
    font-size: 12px;
    font-weight: 600;
    color: $light-text-color;
  }
}
</style>
